import { Trans, useTranslation } from "next-i18next"
import { signInWithGoogle } from "../../../utils/auth"
import { GoogleLoginButton } from "react-social-login-buttons"
import { buildAbsoluteUrl } from "../../../utils/browser"

function SignInForm({ mode = "mind-r" }) {
  const { t } = useTranslation("common")
  return (
    <>
      <div className="m-0 p-0 mb-10 font-sans max-w-xs">
        <Trans
          i18nKey="SIGNIN_DONT_HAVE_ACCOUNT"
          components={{
            signup: (
              <a
                href={buildAbsoluteUrl(
                  `/sign-up${mode === "voxme" ? "-voxme" : ""}`,
                  true
                )}
                className="text-blue-600 font-bold hover:text-blue-800"
              />
            ),
          }}
        />

        <div className="my-5">
          <GoogleLoginButton
            style={{
              border: "2px solid #A8B9BF",
              borderRadius: "20px",
              boxShadow: "none",
            }}
            onClick={signInWithGoogle}
          >
            {t("SIGNIN_GOOGLE_BUTTON")}
          </GoogleLoginButton>
        </div>
      </div>
    </>
  )
}

export default SignInForm
